<script setup>
  import { computed } from 'vue';
  import LoginPage from './auth/LoginPage.vue';
  import { authState } from './auth';

  const loggedIn = computed(() => Boolean(authState.token && authState.user));
</script>
<template>
  <div v-if="loggedIn" id="app">
    <router-view />
  </div>
  <LoginPage v-else />
</template>
<script>
export default {
  name: "App",
  created () {
      document.title = process.env.VUE_APP_TITLE;
  },
  data: function () {
    return { status: false };
  },
  mounted() {

    $("ul.tabs li").click(function () {
      var $this = $(this);
      var $theTab = $(this).attr("id");
      console.log($theTab);
      if ($this.hasClass("active")) {
        // do nothing
      } else {
        $this
          .closest(".tabs_wrapper")
          .find("ul.tabs li, .tabs_container .tab_content")
          .removeClass("active");
        $(
          '.tabs_container .tab_content[data-tab="' +
            $theTab +
            '"], ul.tabs li[id="' +
            $theTab +
            '"]'
        ).addClass("active");
      }
    });
 
  },
};
</script>
